module.exports = __webpack_public_path__ + "img/42.6fca3948.png";